import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { CompanyGroupFacade } from './+state';
import { CompanyGroupStateModule } from './+state/company-group.state.module';

import {
  CompanyGroupService
} from './services';

@NgModule({
  imports: [CommonModule, CompanyGroupStateModule],
})
export class DomainCompanyGroupModule {
  public static forRoot(): ModuleWithProviders {
    return {
      ngModule: DomainCompanyGroupModule,
      providers: [
        CompanyGroupService,
        CompanyGroupFacade
      ],
    };
  }
}
